import { getIdAndEmitterTypeFromZoneEmitterTypeKey } from 'App/Map/_utils/irrigationZoneEmitterTypeKeyUtil'
import type { TIrrigationActivityForPointOrZone } from 'App/Map/CurrentValuesMap/caches/StationValuesCache/StationValuesCache'
import { globalLanguageStore, translate } from 'i18n/i18n'
import type { TIrrigationZoneEmitterId } from 'stores/fieldAssetStore/helperTypes'
import { mapApiEmitterTypeToLabel } from 'utils/mapApiEmitterTypeToLabel'
import { unitConverter } from 'utils/unitConverter/unitConverter'
import { EmitterStatus } from '../components/EmitterStatus'
import type { formatEmitterData } from './formatEmitterData'
import { getPressureAgeText } from './getPressureAgeText'

export const formatEmitterPressureData = (
  entry: [string, TIrrigationActivityForPointOrZone[string]],
): ReturnType<typeof formatEmitterData> => {
  const [irrigationZoneEmitterId, { getBadgeColors, pressure, status }] = entry

  const { emitterType } = getIdAndEmitterTypeFromZoneEmitterTypeKey(
    irrigationZoneEmitterId as TIrrigationZoneEmitterId,
  )

  const hasReading = pressure?.state === 'LIVE' || pressure?.state === 'STALE'
  const pressureValue = unitConverter.irrigationPressure(pressure?.psi)

  return {
    id: irrigationZoneEmitterId,
    emitter: (
      <div css={{ display: 'flex', gap: 5, alignItems: 'center' }}>
        <EmitterStatus status={status} />
        <div>{mapApiEmitterTypeToLabel(emitterType)}</div>
      </div>
    ),
    duration: (
      <div css={{ display: 'flex', gap: 5, alignItems: 'center' }}>
        <div css={{ ...getBadgeColors(), padding: '4px 8px', borderRadius: 5, fontWeight: 700 }}>
          {hasReading ? pressureValue.value() : translate.phrases.templates('-')}
        </div>
        {hasReading && <div css={{ opacity: 0.8 }}>{pressureValue.suffix()}</div>}
      </div>
    ),
    applied: (
      <div css={{ opacity: 0.8, fontSize: 13, whiteSpace: 'nowrap' }}>
        {pressure?.timestamp
          ? getPressureAgeText({
              language: globalLanguageStore.getState(),
              nowMs: Date.now(),
              timestamp: pressure.timestamp,
            })
          : ''}
      </div>
    ),
  }
}
